"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _clsx2 = _interopRequireDefault(require("clsx"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Tag = function Tag(props) {
  var block = props.block,
    color = props.color,
    _props$maxLines = props.maxLines,
    maxLines = _props$maxLines === void 0 ? 1 : _props$maxLines,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    className = props.className;
  var Wrapper = block ? 'div' : 'span';
  var tagStyle = _objectSpread({
    backgroundColor: color
  }, style);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('tag'), (0, _getPrefixCls.getPrefixCls)("tag-ellipsis-".concat(maxLines)), className, (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('tag-block'), block)),
    style: tagStyle
  }, props.children);
};
exports.Tag = Tag;